import { Box, Flex } from "@similarweb/ui-components/foundations";

import { StyledWrappedPreview, StyledIconWrapper } from "../../containers/EnrichmentCsvContainer/style";

import type { ContactsSummaryProps } from "./type";

export const ContactsEnrichmentSummary = ({ badge, infoTooltip, isOutOfQuota, summaryText }: ContactsSummaryProps) => {
    return (
        <StyledWrappedPreview
            isOutOfQuota={isOutOfQuota}
            className="preview-hint"
        >
            <Flex>
                <Box>{summaryText}</Box>
                <StyledIconWrapper>{infoTooltip}</StyledIconWrapper>
            </Flex>

            {badge}
        </StyledWrappedPreview>
    );
};
